export const templateFn = function anonymous(locals, escapeFn, include, rethrow
) {
"use strict";
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"nb-menu-item\">\n  <span\n    aria-label=\"<%= $ctrl.buttonText %>\"\n    aria-expanded=\"<%= $ctrl.active || false %>\"\n    class=\"nb-switcher-button\"\n    id=\"<%= $ctrl._elementId %>\"\n    role=\"button\"\n    tabindex=\"0\"\n    <%- $ctrl.tooltip.target %>\n  >\n    <div class=\"nb-switcher-button__target hide-mobile\">\n      <%- $ctrl.buttonText + $ctrl.iconSvg %>\n    </div>\n    <div class=\"nb-switcher-button__target mobile-only\">\n      <%- ($ctrl.mobileButtonText || $ctrl.buttonText) + $ctrl.mobileIconSvg %>\n    </div>\n  </span>\n  <%- $ctrl.dropdown %>\n</div>\n\n"
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
$ctrl = __locals.$ctrl,
  config = __locals.config,
  formatDate = __locals.formatDate,
  hasTouch = __locals.hasTouch,
  initializeCSSVars = __locals.initializeCSSVars,
  initialsFromFullName = __locals.initialsFromFullName,
  multiToggleFactory = __locals.multiToggleFactory,
  t = __locals.t,
  htmlWebpackPlugin = __locals.htmlWebpackPlugin;
    ; __append("<div class=\"nb-menu-item\">\n  <span\n    aria-label=\"")
    ; __line = 3
    ; __append(escapeFn( $ctrl.buttonText ))
    ; __append("\"\n    aria-expanded=\"")
    ; __line = 4
    ; __append(escapeFn( $ctrl.active || false ))
    ; __append("\"\n    class=\"nb-switcher-button\"\n    id=\"")
    ; __line = 6
    ; __append(escapeFn( $ctrl._elementId ))
    ; __append("\"\n    role=\"button\"\n    tabindex=\"0\"\n    ")
    ; __line = 9
    ; __append( $ctrl.tooltip.target )
    ; __append("\n  >\n    <div class=\"nb-switcher-button__target hide-mobile\">\n      ")
    ; __line = 12
    ; __append( $ctrl.buttonText + $ctrl.iconSvg )
    ; __append("\n    </div>\n    <div class=\"nb-switcher-button__target mobile-only\">\n      ")
    ; __line = 15
    ; __append( ($ctrl.mobileButtonText || $ctrl.buttonText) + $ctrl.mobileIconSvg )
    ; __append("\n    </div>\n  </span>\n  ")
    ; __line = 18
    ; __append( $ctrl.dropdown )
    ; __append("\n</div>\n\n")
    ; __line = 21
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}; export default templateFn